import * as React from 'react'

import ItemPriceAndCTAs from '../common/ItemPriceAndCTAs'
import type { DetailItemCardVariant } from '../common/types'
import HotelCtaContent from '../CTAContent/HotelCtaContent'
import { PlannedItemPriceContent } from './PlannedItemPriceContent'

import useAccommodationOfferAvailable from 'tripPlanner/hooks/useAccommodationOfferAvailable'
import type { AccommodationItem } from 'tripPlanner/types/tripItem'
import { isLeBookmark, isLeBooking } from 'tripPlanner/utils'
import { buildProductLink } from 'tripPlanner/utils/bookmark/restoreCart'
import { getAccommodationPriceAndLabel } from 'tripPlanner/utils/hotel'

interface Props {
  item: AccommodationItem
  offer: App.HotelOffer | App.BundleOffer | App.BedbankOffer | App.VillaOffer
  variant: DetailItemCardVariant
}

function HotelPriceAndCTAs({ item, offer, variant }: Props) {
  let priceAreaContent: React.ReactElement | null = null
  let ctaAreaContent: React.ReactElement | null = null

  const savedItemData = 'savedItemData' in item ? item.savedItemData : undefined
  const isOfferAvailable = useAccommodationOfferAvailable(
    offer,
    savedItemData,
    offer.id,
  )

  if (item.isSuggested) {
    // We don't currently do suggested hotels. If we ever do, update this.
    return null
  }

  let offerLink: string | undefined = undefined

  if (isLeBookmark(item)) {
    const { currencyCode } = item.savedItemData

    const { price } =
      getAccommodationPriceAndLabel(offer, item.savedItemData)

    priceAreaContent = (
      <PlannedItemPriceContent
        price={price}
        currencyCode={currencyCode}
        isOfferAvailable={isOfferAvailable}
      />
    )

    offerLink = buildProductLink(item, { offer }) ?? ''

    ctaAreaContent = (
      <HotelCtaContent
        offerLink={offerLink}
        item={item}
        isOfferAvailable={isOfferAvailable}
        variant={variant}
        offer={offer}
      />
    )
  } else if (isLeBooking(item)) {
    ctaAreaContent = (
      <HotelCtaContent
        item={item}
        isOfferAvailable={isOfferAvailable}
        variant={variant}
        offer={offer}
      />
    )
  }

  return (
    <ItemPriceAndCTAs>
      {priceAreaContent && <div className="price-area">{priceAreaContent}</div>}
      {ctaAreaContent && <div className="cta-area">{ctaAreaContent}</div>}
    </ItemPriceAndCTAs>
  )
}

export default HotelPriceAndCTAs
